module.exports = __webpack_public_path__ + "static/media/headerLogo.242d2095.png";